export default "__VITE_ASSET__BCOuEVu___"